import {
  DYNAMIC_BONUS_CAMPAIGN_STATUS,
  type DynamicBonusCampaignStatus,
} from "./types";

/** Active/paused/expired: banner/display/deeplink only (BONENG-996, BONENG-1157). */
export const BANNER_ONLY_EDIT_STATUSES = new Set<DynamicBonusCampaignStatus>([
  DYNAMIC_BONUS_CAMPAIGN_STATUS.ACTIVE,
  DYNAMIC_BONUS_CAMPAIGN_STATUS.PAUSED,
  DYNAMIC_BONUS_CAMPAIGN_STATUS.EXPIRED,
]);

/** Archived: fully read-only (BONENG-996). */
export const READ_ONLY_STATUSES = new Set<DynamicBonusCampaignStatus>([
  DYNAMIC_BONUS_CAMPAIGN_STATUS.ARCHIVED,
]);

export const isBannerOnlyEditStatus = (
  status: DynamicBonusCampaignStatus,
): boolean => BANNER_ONLY_EDIT_STATUSES.has(status);

export const isFullyReadOnlyStatus = (
  status: DynamicBonusCampaignStatus,
): boolean => READ_ONLY_STATUSES.has(status);
